import { NuxxumWordmark } from "@/components/NuxxumLogo";

const ARCS = [
  { d: "M17.64 11.53 A14 14 0 0 0 11.53 17.64", color: "#5B52EB", dx: "-18px", dy: "-18px", delay: "0s" },
  { d: "M30.36 11.53 A14 14 0 0 1 36.47 17.64", color: "#45C4B0", dx: "18px", dy: "-18px", delay: ".09s" },
  { d: "M36.47 30.36 A14 14 0 0 1 30.36 36.47", color: "#F0964C", dx: "18px", dy: "18px", delay: ".18s" },
  { d: "M11.53 30.36 A14 14 0 0 0 17.64 36.47", color: "#E85D45", dx: "-18px", dy: "18px", delay: ".27s" },
];

export const SplashScreen = () => (
  <div className="fixed inset-0 z-[100] bg-background flex flex-col items-center justify-center gap-6" data-testid="splash-screen">
    <svg width="84" height="84" viewBox="0 0 48 48" fill="none" aria-label="nuxxum" role="img">
      {ARCS.map((a) => (
        <path key={a.color} d={a.d} stroke={a.color} strokeWidth="10.5" strokeLinecap="round" fill="none"
          className="nx-arc" style={{ "--nx-dx": a.dx, "--nx-dy": a.dy, animationDelay: a.delay }} />
      ))}
    </svg>
    <div className="nx-word">
      <NuxxumWordmark className="text-3xl" />
    </div>
  </div>
);
